import { Head } from "@inertiajs/react"
import { AppShell } from "@/components/AppShell"
import { TrendingUp } from "lucide-react"

export default function Show() {
  return (
    <>
      <Head title="BP Closing Stock">
        <meta
          name="description"
          content="Laporan closing stock untuk Beauty Promoters akan segera tersedia."
        />
        <meta property="og:title" content="BP Closing Stock" />
        <meta
          property="og:description"
          content="Laporan closing stock untuk Beauty Promoters akan segera tersedia."
        />
      </Head>
      <AppShell>
        <div className="mb-2 flex items-center gap-1.5 text-xs text-ink-muted">
          <span>Data</span>
          <span>/</span>
          <span>Beauty Promoters</span>
          <span>/</span>
          <span className="text-ink-body font-medium">BP Closing Stock</span>
        </div>

        <div className="border-b border-hairline pb-6">
          <h1>BP Closing Stock</h1>
          <p className="mt-1 text-sm text-ink-muted">
            Laporan closing stock untuk Beauty Promoters.
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-hairline px-6 py-16 text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-accent/10">
            <TrendingUp className="h-8 w-8 text-accent" />
          </div>
          <h2 className="text-lg font-semibold text-ink-display">Coming Soon</h2>
          <p className="mt-2 max-w-md text-sm text-ink-muted">
            Laporan closing stock untuk Beauty Promoters akan segera tersedia. Fitur ini akan memungkinkan Anda untuk mengupload dan mengelola data closing stock bulanan dari berbagai region.
          </p>
          <div className="mt-6 rounded-md bg-surface px-4 py-3 text-xs text-ink-muted">
            <p className="font-medium text-ink-body">Fitur yang akan datang:</p>
            <ul className="mt-2 space-y-1">
              <li>• Upload file Excel closing stock bulanan</li>
              <li>• Tracking history upload per region</li>
              <li>• Analisis dan visualisasi data closing stock</li>
              <li>• Export data ke berbagai format</li>
            </ul>
          </div>
        </div>
      </AppShell>
    </>
  )
}
